import { defineStore } from 'pinia';
import apiRequest from '../api/ApiRequestService';
import { useStorage } from '@vueuse/core';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export const useConferenceStore = defineStore({
    id: 'conference',

    state: () => ({
        conference: {
            state: {
                page: 1
            },
            data: [],
            per_page: 0,
            total: 0
        },
        conferenceDetails: {}, 
        loading_elements: false,
        preview: {},
        error: {}, 
        latestConference: [],
        searchTest: '', 
        showEventBox: false
    }),

    getters: {
        getConference: (state) => state.conference?.data ?? []
    },

    actions: {
        async fetchConferences() { 
            try {
                this.loading_elements = true;
                const payload = {};
                payload.page = this.conference.state.page;
                payload.search_txt = this.searchTest; 
                await apiRequest.get('dashboard/conference', payload).then((response) => {
                    if (response.status === 'success') {
                        this.conference.data = response.data?.data ?? [];
                        this.conference.total = response.data?.meta?.total ?? 0;
                        this.conference.per_page = response.data?.meta?.per_page ?? 10;
                    } else {
                        this.error = response.message ?? 'Something went wrong, please try again later';
                    }
                    //remove leads from loading elements
                    this.loading_elements = false;
                });
            } catch (error) {
                this.loading_elements = false;
                this.error = 'Something went wrong, please try again later';
            }
        },
        async fetchLatestConference(UserService) {
            // console.log('fetchInvoices');
            try {
                // this.loading_elements = true;
                const payload = {};  
                await apiRequest.get('dashboard/latest-conference').then((response) => {
                    if (response.status === 'success') {  
                        if( response.data ){ 
                            this.latestConference = response.data ?? [];   
                            this.setEventBox(UserService);
                        } 
                    } else {
                        this.error = response.message ?? 'Something went wrong, please try again later';
                    }
                    //remove leads from loading elements
                    // this.loading_elements = false;
                });
            } catch (error) {
                // this.loading_elements = false;
                this.error = 'Something went wrong, please try again later';
            }
        },
        async fetchConferenceDetails(tag) { 
            try {
                this.loading_elements = true; 
                await apiRequest.get('dashboard/conference/'+tag, {}).then((response) => {
                    if (response.status === 'success') { 
                        this.conferenceDetails = response.data ?? [];
                    } else {
                        this.error = response.message ?? 'Something went wrong, please try again later';
                    }
                    //remove leads from loading elements
                    this.loading_elements = false;
                });
            } catch (error) {
                this.loading_elements = false;
                this.error = 'Something went wrong, please try again later';
            }
        },
        setEventBox(UserService) {
            let alreadyRemoved = useStorage('event-' + UserService.getUserInfo.email + '-' + this.latestConference.id + '-remove');

            const conferenceDate = this.latestConference.event_end_date || this.latestConference.event_start_date;
            const isConferencePassed = conferenceDate ? dayjs.tz(conferenceDate, 'Europe/Berlin').isBefore(dayjs().tz('Europe/Berlin'), 'day') : false;

            this.showEventBox = !alreadyRemoved.value && !isConferencePassed;
        },
        removeEventBox(UserService) {
            useStorage('event-' + UserService.getUserInfo.email + '-' + this.latestConference.id + '-remove', true);
            this.showEventBox = false;
        }
    }
});

export default useConferenceStore;
